import qs from 'qs';
import _ from 'lodash';
import { request } from '../utils';

export const getList = async () => request(`/currencies/all`);
